// extracted by mini-css-extract-plugin
export default {"paginacao":"Paginacao_paginacao__7cnmT","active":"Paginacao_active__1M+k8","info":"Paginacao_info__cOhEp","table_logins":"Paginacao_table_logins__PTn88"};